module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "better-input-tag",
    class: {
      "full-radius": _vm.typeOnly,
      "possibilities-list-open": _vm.showingPossibilities && !_vm.typeOnly,
      "possibilities-list-closed": _vm.showingPossibilities && !_vm.typeOnly,
      "disable-input": _vm.disableInput
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.boxClicked.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.tags), function(tag, index) {
    return (_vm.tags.length > 0) ? _c('span', {
      class: _vm.paddingClass
    }, [_vm._v(_vm._s(tag[_vm.props.name])), (!_vm.readOnly && !_vm.disableInput) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeTag(index)
        }
      }
    }, [_vm._v("x")]) : _vm._e()]) : _vm._e()
  }), _vm._l((_vm.defaultTagsIfEmpty), function(tag, index) {
    return (_vm.tags.length === 0 && _vm.defaultTagsIfEmpty.length > 0) ? _c('span', {
      staticClass: "full-padding"
    }, [_vm._v(_vm._s(tag[_vm.props.name]))]) : _vm._e()
  }), (_vm.inputExists) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    attrs: {
      "placeholder": _vm.$t(_vm.placeHolders.input),
      "title": _vm.$t(_vm.placeHolders.input),
      "disabled": _vm.disableInput
    },
    domProps: {
      "value": (_vm.tag)
    },
    on: {
      "focus": _vm.showPossibilities,
      "blur": _vm.close,
      "keydown": _vm.handleKey,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tag = $event.target.value
      }
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showingPossibilities) ? _c('div', {
    staticClass: "possibilities-list col-md-12 px-0"
  }, _vm._l((_vm.possibilities), function(item, index) {
    return _c('div', {
      staticClass: "possibilities-list-item",
      class: item.__blocked ? "blocked" : _vm.highlightedIndex === index ? "highlighted" : "",
      on: {
        "mousedown": function($event) {
          return _vm.addTag(item)
        },
        "mouseover": function($event) {
          return _vm.handleMouse(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item[_vm.props.name]))])])
  }), 0) : _vm._e()])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-169f7ba6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169f7ba6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/input/betterInputTag/betterInputTag.pug
// module id = 1374
// module chunks = 0